import React, { useContext } from "react";
import { Breadcrumb } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { getNomeByRota, Rotas } from "../../../constants/EnumRotas";
import "./Breadcrumb.css";
import { UserContext } from "context/UserContext";
import IntegracaoV1 from "shared/util/integrarFrontEndV1Functions";
interface BreadcrumbProps {
  ocultarCondominio?: boolean;
  nomeCondominio?: string;
  abaAtual?: string;
}

const BreadcrumbComponent: React.FC<BreadcrumbProps> = (props) => {
  const location = useLocation();
  const { condominioContexto } = useContext(UserContext);
  const { redirectToV1 } = IntegracaoV1();
  const paths = location.pathname.split("/").filter((path) => getNomeByRota(`/${path}` as Rotas));

  const breadCrumbList = paths.map((path, index) => {
    return {
      path: path,
      name: getNomeByRota(`/${path}` as Rotas),
      active: index === paths.length - 1 ? true : false,
    };
  });

  if (!props.ocultarCondominio) {
    breadCrumbList.splice(paths.length - 1, 0, {
      path: "",
      name: props.nomeCondominio ? props.nomeCondominio : condominioContexto?.nomeCondominio ?? "",
      active: true,
    });
  }

  return (
    <Breadcrumb className="custom-breadcrumb ">
      <Breadcrumb.Item
        linkAs={Link}
        onClick={() => {
          redirectToV1("/");
        }}
      >
        Início
      </Breadcrumb.Item>
      {breadCrumbList.map((breadCrumbItem, index) => (
        <Breadcrumb.Item
          key={index}
          linkAs={Link}
          linkProps={{ to: `/${breadCrumbItem.path}` }}
          active={breadCrumbItem.active}
        >
          {breadCrumbItem.name}
        </Breadcrumb.Item>
      ))}
      {props.abaAtual && <Breadcrumb.Item active>{props.abaAtual}</Breadcrumb.Item>}
    </Breadcrumb>
  );
};

export default BreadcrumbComponent;
